import { jsx as _jsx } from "react/jsx-runtime";
import { Banner } from '#pplx/frontend/aether/components/Banner/index.js';
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { getOverLimitCount } from '#pplx/frontend/composer-sdk-plugins/input-over-limit-warning/internal/getOverLimitCount.js';
import { InputNotice } from '#pplx/frontend/composer-sdk-plugins/internal/input-notice/InputNotice.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
/** Renders the caller's warning without changing the draft or submission eligibility. */
export function InputOverLimitWarning({ errorMessage }) {
    return (_jsx("div", { role: "alert", children: _jsx(Banner, { title: errorMessage, variant: "error", leadingAccessory: $icon('alert-circle') }) }));
}
/** Renders only positive overflow, including when composed with other input-header content. */
export function InputOverLimitWarningSlot({ count, limit, formatMessage, leadingAccessory = _jsx(Icon, { icon: $icon('alert-circle') }), onClose, }) {
    const overBy = getOverLimitCount(count, limit);
    return overBy > 0 ? (_jsx(InputNotice, { message: formatMessage(overBy), leadingAccessory: leadingAccessory, onClose: onClose, variant: "error", role: "alert" })) : null;
}
//# sourceMappingURL=InputOverLimitWarning.js.map